import { render, staticRenderFns } from "./AddProductsSideBar.vue?vue&type=template&id=d13177b6&scoped=true"
import script from "./AddProductsSideBar.vue?vue&type=script&lang=js"
export * from "./AddProductsSideBar.vue?vue&type=script&lang=js"
import style0 from "./AddProductsSideBar.vue?vue&type=style&index=0&id=d13177b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13177b6",
  null
  
)

export default component.exports